<div class="process-step">
  @if (isProcessing) {
    <div class="processing-container">
      <div class="spinner-container">
        <mat-spinner diameter="80" color="primary"></mat-spinner>
      </div>

      <h3>Processing Payments...</h3>
      <p class="processing-description">
        Please wait while we process {{ matchedCount }} payment{{ matchedCount !== 1 ? 's' : '' }}.
        This may take a few moments.
      </p>

      <div class="progress-info">
        <mat-progress-bar 
          mode="indeterminate" 
          color="primary"
        ></mat-progress-bar>
      </div>

      <div class="processing-tips">
        <mat-icon>info</mat-icon>
        <span>Do not close this window until processing is complete.</span>
      </div>
    </div>
  } @else {
    <div class="completed-container">
      <div class="success-icon">
        <mat-icon>check_circle</mat-icon>
      </div>
      <h3>Processing Complete!</h3>
      <p>All payments have been processed. Redirecting to results...</p>
    </div>
  }
</div>

